import { useState } from "react";
import { motion } from "framer-motion";
import { usePosts } from "../hooks/usePosts";
import PostCard from "../components/PostCard";
import styles from "./Blog.module.css";

export default function Blog() {
  const { posts } = usePosts();
  const allTags = Array.from(new Set(posts.flatMap((p) => p.tags)));
  const allCountries = Array.from(new Set(posts.map((p) => p.country)));
  const [activeFilter, setActiveFilter] = useState<string>("all");

  const filtered =
    activeFilter === "all"
      ? posts
      : posts.filter(
          (p) =>
            p.country === activeFilter || p.tags.includes(activeFilter)
        );

  return (
    <main className={styles.page}>
      <section className={styles.header}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className={styles.label}>All Stories</span>
          <h1 className={styles.title}>Travel Stories</h1>
          <p className={styles.subtitle}>
            Every destination has a story. Here are mine.
          </p>
        </motion.div>
      </section>

      <section className={styles.content}>
        <div className={styles.container}>
          <motion.div
            className={styles.filters}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <button
              className={`${styles.filterBtn} ${
                activeFilter === "all" ? styles.filterActive : ""
              }`}
              onClick={() => setActiveFilter("all")}
            >
              All
            </button>
            {allCountries.map((c) => (
              <button
                key={c}
                className={`${styles.filterBtn} ${
                  activeFilter === c ? styles.filterActive : ""
                }`}
                onClick={() => setActiveFilter(c)}
              >
                {c}
              </button>
            ))}
            {allTags.slice(0, 6).map((t) => (
              <button
                key={t}
                className={`${styles.filterBtn} ${
                  activeFilter === t ? styles.filterActive : ""
                }`}
                onClick={() => setActiveFilter(t)}
              >
                {t}
              </button>
            ))}
          </motion.div>

          <div className={styles.grid}>
            {filtered.map((post, i) => (
              <PostCard key={post.id} post={post} index={i} />
            ))}
          </div>

          {filtered.length === 0 && (
            <p className={styles.empty}>
              No stories found for this filter.
            </p>
          )}
        </div>
      </section>
    </main>
  );
}
